"use client"

import type { AnchorHTMLAttributes, FunctionComponent } from "react"

import { usePathname } from "next/navigation"

import { HomeFilled } from "@jobteaser/spark/components/Icons/HomeFilled"
import { HomeOutlined } from "@jobteaser/spark/components/Icons/HomeOutlined"

import { NavLink } from "./NavLink"

type NavLinkHomeProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string
}

export const NavLinkHome: FunctionComponent<NavLinkHomeProps> = ({ href, ...props }) => {
  const pathname = usePathname()
  const isActive = pathname === href

  return (
    <NavLink {...props} href={href}>
      {isActive ? <HomeFilled size={20} /> : <HomeOutlined size={20} />}
    </NavLink>
  )
}
